export class SetUserCountryAction {
  static readonly type = '[User] Set country';
  constructor(public payload: string | null) {}
}

export class ClearUserStateAction {
  static readonly type = '[User] Clear state';
  constructor() {}
}
